var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fillColor",
    id: "Validation-sidebar-/-Lo-que-ve-nivel-2",
    transform: "translate(-40.000000, -92.000000)",
    fill: "#00B46E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "periodicity",
    transform: "translate(18.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "date"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1093851,30 C27.8218862,30 27.5341372,29.8820766 27.3143879,29.6456915 L22.3301554,24.2858326 C21.890407,23.8130622 21.889907,23.0460219 22.3289054,22.5724439 C22.7679039,22.0991351 23.4804014,22.0985966 23.9198998,22.5713669 L28.1093851,27.0764161 L38.0801002,16.3545445 C38.5195986,15.8812356 39.2318461,15.8820433 39.6710946,16.3556214 C40.110093,16.8291994 40.109593,17.5962397 39.6698446,18.0690101 L28.9043824,29.6456915 C28.6846331,29.8820766 28.3968841,30 28.1093851,30",
    id: "checkmark"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.e76a6ce6db69bea75e6c0c736c97cadb.svg";
export { ForwardRef as ReactComponent };